var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"bg-info-light"},[_c('div',{staticClass:"bg-light padding-20"},[_c('div',{staticClass:"text-right"},[_vm._t("right-btn")],2),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }